import React, { useState } from "react";
import ViewAccessArea from "./ViewAccessArea";
const UploadAccessIcon = ({ page }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      {/* <img
        className="viewAccessBtn"
        src={viewAccessIcon}
        alt="viewAccess"
        onClick={() => {
          console.log(1);
          // setShow(true);
        }}
      /> */}
      <div
        className="viewAccessBtn"
        role="button"
        tabIndex="0"
        aria-label="مدیریت دسترسی مشاهده"
        onClick={() => {
          setShow(true);
        }}
      ></div>
      <ViewAccessArea page={page} onClose={() => setShow(false)} show={show} />
    </div>
  );
};

export default UploadAccessIcon;
